export type DifficultyLevel =
  | "GENERAL"
  | "BEGINNER"
  | "INTERMEDIATE"
  | "ADVANCED";
export type SessionFormat = "CIRCUIT" | "INTERVAL" | "OTHER";

export type SessionRow = {
  sessionid: string;
  code: string;
  sessionName: string;
  category: string; // renamed from workoutType
  createdBy: string;
  createdDate: string;
  status: string;
  workoutType: string;
  type?: string;
};

export interface SubscriberSessionPayload {
  name: string;
  category: string; // renamed from type
  warmupTime: number;
  cooldownTime: number;
  duration?: number;
  difficultyLevels?: DifficultyLevel[];
  formats?: SessionFormat[];
  subscriber?: string;
}

export interface Session extends SubscriberSessionPayload {
  id: number;
  createdAt: string;
  updatedAt: string;
}

export enum SessionDifficultyLevel {
  GENERAL = "GENERAL",
  BEGINNER = "BEGINNER",
  INTERMEDIATE = "INTERMEDIATE",
  ADVANCED = "ADVANCED",
}
